import reset from 'styled-reset'
import { createGlobalStyle } from 'styled-components'

import { BLUE_01, WHITE_01, BLACK_01, GREY_01 } from './colors'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery, maxWidth } from './metrics'

export const GlobalStyle = createGlobalStyle`
	${reset}

	html {
		box-sizing: border-box;
		background-color: ${props => props.background};
		color: ${props => props.theme.foreground};
		transition: background-color 1s, color 1s;
	}
	*, *:before, *:after {
		box-sizing: inherit;
	}

	#CybotCookiebotDialog{
		box-shadow: none !important;
		border: none !important;
		border-radius: 0 !important;
	}

	#CybotCookiebotDialogBodyContentTitle{
		font-family: 'BwGradual-Regular' !important;
		font-size: 16px !important;
		color: ${BLACK_01} !important;
	}

	#CybotCookiebotDialogBodyContentText, .CybotCookiebotDialogDetailBodyContentCookieTypeIntro, #CybotCookiebotDialogDetailBodyContentTextAbout { 
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		line-height: 130% !important;
		color: ${BLACK_01} !important;
	}

	.CybotCookiebotDialogDetailBodyContentCookieTypeTable{
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	.CybotCookiebotDialogDetailBodyContentCookieTypeTable a, .CybotCookiebotDialogBodyLevelDetailsWrapper a{
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	#CybotCookiebotDialogBodyLevelDetailsWrapper{
		text-align: center !important;
	}

	.CybotCookiebotDialogBodyButton{
		color: ${BLUE_01} !important;
		background-color: ${WHITE_01} !important;
		border: 1px solid ${BLUE_01} !important;
		font-family: 'BwGradual-Bold' !important;
		font-size: 10px !important;
		letter-spacing: 0.05em !important;
		text-transform: uppercase !important;
		text-decoration: none !important;
		line-height: ${unit(4)} !important;
		height: ${unit(4)} !important;
		text-align: center !important;
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		width: auto !important;
		padding: 0 ${unit(3)} !important;
		min-width: auto !important;
	}

	#CybotCookiebotDialogBodyLevelButtonAccept, .CybotCookiebotDialogBodyButton:last-child{
		color: ${WHITE_01} !important;
		background-color: ${BLUE_01} !important;
		border: 1px solid ${BLUE_01} !important;
	}

	#CybotCookiebotDialogBodyLevelButtonAccept:hover, .CybotCookiebotDialogBodyButton:hover{
		color: ${WHITE_01} !important;
		background-color: ${BLACK_01} !important;
		border: 1px solid ${BLACK_01} !important;
	}

	#CybotCookiebotDialogBodyLevelButtonsRow{
		height: 34px !important;
	}

	#CybotCookiebotDialogBodyLevelButtonsSelectPane, #CybotCookiebotDialogBodyLevelDetailsWrapper{
		vertical-align: middle !important;
	}

	.CybotCookiebotDialogBodyLevelButtonWrapper label, .CybotCookiebotDialogBodyLevelDetailsButton, #CybotCookiebotDialogBodyLevelDetailsButton{
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	#CybotCookiebotDialogDetailBodyContentCookieContainerNecessary, #CybotCookiebotDialogDetailBodyContentCookieContainerPreference, #CybotCookiebotDialogDetailBodyContentCookieContainerStatistics, #CybotCookiebotDialogDetailBodyContentCookieContainerAdvertising, #CybotCookiebotDialogDetailBodyContentCookieContainerUnclassified {
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	#CybotCookiebotDialogBodyLevelDetailsButton{
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	.CybotCookiebotDialogDetailBodyContentTab{
		font-family: 'Montserrat', sans-serif !important;
		font-size: 11px !important;
		color: ${BLACK_01} !important;
	}

	
`